export default {"src":"/_next/static/media/translate.8beb2e51.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};